import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

/**
 * Labelled select dropdown. In read-only mode it renders the label
 * of the currently selected option (or '-'). In edit mode it renders
 * a shadcn Select.
 */
export const SelectField = ({
  label,
  value,
  options,
  className = '',
  editable = false,
  onChange,
  readOnlyLabel,
  testId,
}) => {
  const selectedLabel = options.find((o) => o.value === value)?.label;

  return (
    <div className={className} data-testid={testId}>
      <label className="text-[10px] text-slate-500 uppercase tracking-wide leading-none block mb-0.5">
        {label}
      </label>
      {editable ? (
        <Select value={value || ''} onValueChange={onChange}>
          <SelectTrigger className="text-xs h-6 font-medium bg-white px-2" data-testid={testId ? `${testId}-trigger` : undefined}>
            <SelectValue placeholder="...">{selectedLabel || '...'}</SelectValue>
          </SelectTrigger>
          <SelectContent>
            {options.map((opt) => (
              <SelectItem key={opt.value} value={opt.value} className="text-xs">
                {opt.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        <div className="text-xs font-medium text-slate-800 bg-white border border-slate-200 rounded px-2 py-1 min-h-[24px] leading-tight">
          {readOnlyLabel || selectedLabel || value || '-'}
        </div>
      )}
    </div>
  );
};

export default SelectField;
